module.exports = __webpack_public_path__ + "img/pavel.z__600x600.9730ffde.jpg";